'use client';
import { atom, useAtom, useSetAtom, WritableAtom } from 'jotai';

export const floatingTriggerVisibilityAtom = atom<boolean>(true) as WritableAtom<
  boolean,
  [boolean],
  void
>;

export const setFloatingTriggerVisibilityAtom = atom(null, (get, set, visible: boolean) => {
  set(floatingTriggerVisibilityAtom, visible);
});

export function useFloatingTriggerVisibility() {
  const [visible] = useAtom(floatingTriggerVisibilityAtom);
  const setVisibility = useSetAtom(setFloatingTriggerVisibilityAtom);

  return {
    isFloatingTriggerVisible: visible,
    setFloatingTriggerVisibility: (value: boolean) => setVisibility(value),
  };
}
